import CalloutRepository from "../CalloutRepository"

export default class PricingCallout extends CalloutRepository {
    static schemaId = "pricing_callout"

    constructor() {
        super(PricingCallout.schemaId)
    }
}
